import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { GetCandidate } from 'src/app/models/candidate/get-candidate';
import { GetAddress } from 'src/app/models/security/register-request';
import { UserRoleIds } from 'src/app/models/security/user-role-enum';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { DropdownService } from 'src/app/services/dropdown.service';
import { FileStorageService } from 'src/app/services/file-storage.service';
import { UserService } from 'src/app/services/user.service';
import { JobOfferListComponent } from "../job-offer-candidates/job-offer-list/job-offer-list.component";
import { ViewTrackingService, ViewType } from 'src/app/services/view-tracking.service';

@Component({
  selector: 'app-main-candidates',
  templateUrl: './main-candidates.component.html',
  styles: [],
  standalone: true,
  imports: [CarouselComponent, CommonModule, JobOfferListComponent],
  providers: [DropdownService]
})
export class MainCandidatesComponent implements OnInit {

  items: any[] = [{
    logo: 'assets/Images/logo-compania.jpg',
    oferta: 'Desarrollador Android / IOS',
    compania: 'Inversion Futuro SRL',
    tiempo: 'Tiempo Completo',
    date: '28/May/2024',
    location: 'Santo Domingo'
  }, {
    logo: 'assets/Images/logo-compania.jpg',
    oferta: 'Desarrollador Frontend en Angular',
    compania: 'Tecnologias y Desarrollo SRL',
    tiempo: 'Tiempo Completo',
    date: '26/May/2024',
    location: 'Santo Domingo'
  }];

  isLoading: boolean = false;
  isFound: boolean = false;
  candidate: GetCandidate | null | undefined = null;
  addresses: GetAddress[] = [];

  authService = inject(AuthService);
  alertService = inject(AlertService);
  userService = inject(UserService);
  docService = inject(FileStorageService);
  dropdownService = inject(DropdownService);
  viewTrackingService = inject(ViewTrackingService);

  typePerson: number = UserRoleIds.Admin;
  rolesId = UserRoleIds;

  profileImage: string = 'assets/Images/user.png';

  principalAddress: GetAddress | undefined | null = null;
  
  // Estadísticas de aplicaciones
  jobApplicationsCount: number = 0;

  constructor() { }

  ngOnInit(): void {
    this.getCandidateData();
    this.getJobApplicationsCount();
  }

  getCandidateData(): void {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getCandidate(userId).subscribe({
      next: (res) => {
        this.candidate = res;
        if (res) {
          this.isFound = true;
          this.profileImage = this.docService.getFileUrl(`${res.photoFileId}`);
          this.getAddresses();
          this.loadProfileViews(); // Load public profile view counter
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses() {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAddresses(userId).subscribe({
      next: (res) => {
        this.addresses = res;
        if (res && res.length > 0) {
          this.principalAddress = res.find((address) => address.isPrimary);
          if (!this.principalAddress) {
            this.principalAddress = res[0];
          }
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getJobApplicationsCount(): void {
    this.dropdownService.GetOptions(DropDownKeywords.JobApplicationsCount,null,undefined,true).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          const applicationStats = res.find(x => x.id === 1);
          if (applicationStats) {
            this.jobApplicationsCount = applicationStats.relatedId || 0;
          }
        }
      }
    });
  }

  loadProfileViews(): void {
    // Get the candidate's public resumeId to query views
    const resumeId = this.candidate?.publicResumeId || this.candidate?.professionalProfileId;
    
    if (!resumeId) {
      return;
    }
    
    this.viewTrackingService.getViewsCount(ViewType.IndependentProfile, resumeId).subscribe({
      next: (viewsCount) => {
        if (this.candidate) {
          this.candidate.profileViewsCount = viewsCount;
        }
      },
      error: (error) => {
        console.error('Error loading profile views:', error);
      }
    });
  }
}
